import type { RefObject } from "react";

import { usePlaybackSpaceShortcut } from "../Video/usePlaybackSpaceShortcut";
import type { MediaTimelineShortcutKeyEvent } from "./useMediaTimelineShortcuts";

/** A sole eligible rich timeline also owns Space before focus enters the bar. */
export function useMediaTimelineGlobalSpaceShortcut(
  rootRef: RefObject<HTMLElement | null>,
  onKeyDown: (event: MediaTimelineShortcutKeyEvent) => boolean,
  enabled: boolean,
): void {
  usePlaybackSpaceShortcut(rootRef, onKeyDown, enabled, rootRef, true);
}
